import React from 'react';
import { Hero } from '../components/Hero';
import { SocialProofTicker } from '../components/SocialProofTicker';
import { ActionKit } from '../components/ActionKit';
import { Testimonials } from '../components/Testimonials';
import { ChapterList } from '../components/ChapterList';
import { Pricing } from '../components/Pricing';
import { FAQ } from '../components/FAQ';
import { ShareSection } from '../components/ShareSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-[#0c1222] text-white overflow-x-hidden" data-id="element-255">
      <Hero data-id="element-256" />
      <SocialProofTicker data-id="element-257" />
      <ActionKit data-id="element-258" />
      <Testimonials data-id="element-259" />
      <ChapterList data-id="element-260" />
      <Pricing data-id="element-261" />
      <FAQ data-id="element-262" />
      <ShareSection data-id="element-263" />
      <Footer data-id="element-264" />
    </div>;
}